/* Keep all prices, availability and cart IDs in server-rendered Liquid forms. */
(() => {
  'use strict';
  const shop = document.getElementById('co-shop');
  if (!shop || shop.dataset.ready) return;
  const grid = shop.querySelector('#co-grid');
  const filter = shop.querySelector('.co-size-filter');
  const result = shop.querySelector('.co-results');
  const empty = shop.querySelector('.co-no-results');
  const splits = document.getElementById('co-split-shop');
  const topperSection = document.querySelector('.co-topper-section');
  const topperGrid = document.getElementById('co-topper-grid');
  if (!grid || !filter || !result || !empty) return;

  const families = new Map();
  Array.from(grid.querySelectorAll('.co-card')).forEach(card => {
    if (card.dataset.family === 'topper' && topperGrid) {
      topperGrid.append(card);
      topperSection.hidden = false;
      return;
    }
    const existing = families.get(card.dataset.family);
    if (existing) {
      card.querySelectorAll('.co-srow').forEach(row => existing.querySelector('.co-sizes').append(row));
      const anchor = document.createElement('span');
      anchor.id = card.id;
      existing.prepend(anchor);
      card.remove();
    } else families.set(card.dataset.family, card);
  });

  const cards = Array.from(families.values());
  const allCards = cards.concat(topperGrid ? Array.from(topperGrid.querySelectorAll('.co-card')) : []);
  const sizeOrder = ['Twin', 'Twin XL', 'Full', 'Queen', 'King', 'Cal King'];
  const sortSizes = values => [...new Set(values)].sort((a, b) => {
    const ai = sizeOrder.indexOf(a), bi = sizeOrder.indexOf(b);
    return (ai < 0 ? 99 : ai) - (bi < 0 ? 99 : bi);
  });
  const state = new Map();
  const option = (value, label = value) => new Option(label, value);

  allCards.forEach(card => {
    const rows = Array.from(card.querySelectorAll('.co-srow'));
    if (!rows.length) return;
    const controls = document.createElement('div');
    controls.className = 'co-card-controls';
    const makeSelect = labelText => {
      const label = document.createElement('label');
      const text = document.createElement('span');
      text.textContent = labelText;
      const select = document.createElement('select');
      select.setAttribute('aria-label', card.dataset.name + ' ' + labelText);
      label.append(text, select);
      controls.append(label);
      return select;
    };
    const size = makeSelect('Size');
    const feel = makeSelect('Feel');
    const title = card.querySelector('h3');
    title.textContent = card.dataset.name;
    card.querySelector('.co-sizes').before(controls);
    const showRow = () => {
      const selected = rows.find(row => row.dataset.size === size.value && (row.dataset.feel || 'Standard') === feel.value);
      rows.forEach(row => { row.hidden = row !== selected; });
      if (!selected) return;
      card.querySelector('.co-detail-link').href = selected.dataset.url;
      const blurb = card.querySelector('.co-blurb');
      if (blurb) blurb.textContent = selected.dataset.blurb;
      const button = selected.querySelector('button');
      button.textContent = 'Add to Cart';
      button.setAttribute('aria-label', 'Add ' + card.dataset.name + ' ' + size.value + ' ' + (feel.value === 'Standard' ? '' : feel.value) + ' to cart');
    };
    const updateFeel = () => {
      const previous = feel.value;
      const feels = [...new Set(rows.filter(row => row.dataset.size === size.value).map(row => row.dataset.feel || 'Standard'))];
      feel.replaceChildren(...feels.map(value => option(value)));
      if (feels.includes(previous)) feel.value = previous;
      else if (feels.includes('Medium')) feel.value = 'Medium';
      feel.disabled = feels.length < 2;
      feel.parentElement.hidden = feels.length === 0 || (feels.length === 1 && feels[0] === 'Standard');
      controls.style.gridTemplateColumns = feel.parentElement.hidden ? '1fr' : '';
      showRow();
    };
    const updateSizes = globalSize => {
      const previous = size.value;
      const available = sortSizes(rows.map(row => row.dataset.size));
      const shown = globalSize === 'All sizes' ? available : available.filter(value => value === globalSize);
      card.hidden = !shown.length;
      size.replaceChildren(...shown.map(value => option(value)));
      if (shown.includes(previous)) size.value = previous;
      size.disabled = shown.length === 1;
      updateFeel();
    };
    size.addEventListener('change', updateFeel);
    feel.addEventListener('change', showRow);
    state.set(card, updateSizes);
    updateSizes('All sizes');
    card.classList.add('is-selectable');
  });

  const availableSizes = sortSizes(cards.flatMap(card => Array.from(card.querySelectorAll('.co-srow'), row => row.dataset.size)));
  // Always retain Queen and Full so unavailable sizes get an honest alternative.
  const filters = ['All sizes', ...sortSizes([...availableSizes, 'Queen', 'Full'])];
  if (splits) filters.push('Split King');
  let selected = 'All sizes';
  const update = value => {
    selected = value;
    const split = value === 'Split King';
    grid.hidden = split;
    if (splits) splits.hidden = !split;
    cards.forEach(card => state.get(card)?.(split ? 'All sizes' : value));
    filter.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.textContent === value)));
    const count = split ? splits.querySelectorAll('.sk-card').length : cards.filter(card => !card.hidden).length;
    empty.hidden = count > 0;
    result.textContent = split ? 'Two Twin XL mattresses. Choose each side below; bases sold separately.' :
      count + ' mattress ' + (count === 1 ? 'option' : 'options') + (value === 'All sizes' ? ' · Choose a size to narrow your options.' : ' available in ' + value + '.');
    if (value === 'Queen' && count > 0) result.textContent += ' Looking for another budget? Compare our regular mattress sale below.';
    const alternate = shop.querySelector('.co-queen-alternative');
    if (alternate) alternate.hidden = value !== 'Queen' || !count;
  };
  filters.forEach(value => {
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = value;
    button.setAttribute('aria-pressed', String(value === selected));
    button.addEventListener('click', () => update(value));
    filter.append(button);
  });
  const alternate = document.createElement('p');
  alternate.className = 'co-help co-queen-alternative';
  const link = document.createElement('a');
  link.href = '/pages/sale';
  link.textContent = 'Compare regular-sale mattresses →';
  alternate.append(link);
  empty.after(alternate);
  filter.hidden = false;
  result.hidden = false;
  update(selected);
  shop.dataset.ready = 'true';

  // Recalculate split totals for the exact two variants; never assume feels cost the same.
  const money = cents => new Intl.NumberFormat('en-CA', {style:'currency',currency:'CAD',maximumFractionDigits:2}).format(cents / 100);
  splits?.querySelectorAll('.sk-form').forEach(form => {
    const selectors = Array.from(form.querySelectorAll('select'));
    if (!selectors.length) return; // Single-feel forms have an exact Liquid total.
    const refresh = () => {
      const chosen = selectors.map(select => select.selectedOptions[0]);
      const total = chosen.reduce((sum, item) => sum + Number(item.dataset.price), 0);
      const compare = chosen.reduce((sum, item) => sum + Math.max(Number(item.dataset.compare), Number(item.dataset.price)), 0);
      const prices = form.querySelector('.sk-price');
      prices.querySelector('.sk-now').textContent = money(total);
      const was = prices.querySelector('.sk-was');
      const save = prices.querySelector('.sk-save');
      if (was) { was.textContent = money(compare); was.hidden = compare <= total; }
      if (save) { save.textContent = 'Save ' + money(compare - total); save.hidden = compare <= total; }
    };
    selectors.forEach(select => select.addEventListener('change', refresh));
    refresh();
  });
})();
